module.exports = __webpack_public_path__ + "img/SwissTrust4.242476c1.png";